import { connect } from 'react-redux';
import { Actions } from '@/actions/restricted';

function mapStateToProps(guidProp, state, ownProps) {
  const ownerGuid = ownProps[guidProp];

  const selectedContactsState =
    state.restricted.contact.selected_contacts_in_search || {};

  const selectedContacts = selectedContactsState[ownerGuid]
    ? selectedContactsState[ownerGuid]
    : [];

  return { selectedContacts };
}

function mapDispatchToProps(guidProp, dispatch, ownProps) {
  const ownerGuid = ownProps[guidProp];

  return {
    setSelectedContacts: contacts => {
      dispatch(
        Actions.selected_contacts_in_search({
          [ownerGuid]: contacts,
        })
      );
    },
  };
}
export default function(component, guidProp = 'guid') {
  return connect(
    mapStateToProps.bind(null, guidProp),
    mapDispatchToProps.bind(null, guidProp)
  )(component);
}



// WEBPACK FOOTER //
// ./src/connectHOCs/Contacts/selectedContactsInSearch.js